module.exports = __webpack_public_path__ + "img/workshop.129b336f.jpg";